"use strict";
angular.module('productManageMentAppRouterModule', [
    'productManageMentAppSiteRouterModule',
    'productManageMentAppChannelModule',
    'productManageMentAppColumnModule'
]).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.productmanage.app.site", {
            url: '/site',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/site/site_tpl.html',
                    controller: 'manageAppSiteController',
                }
            }
        })
        .state("manageconfig.productmanage.app.channel", {
            url: '/channel?selectTab&status',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/channel/channelMge_tpl.html',
                    controller: 'productManageMentAppChannelCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.column", {
            url: '/column?channel&selectTab&parentchnl&status',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/column/columnMge_tpl.html',
                    controller: 'productManageMentAppColumnCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.template", {
            url: '/template?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/template/templateMge_tpl.html',
                    controller: 'productManageMentAppTemplateCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.externalsys", {
            url: '/externalsys?selectTab',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/externalSys/externalSys_tpl.html',
                    controller: 'productManageMentAppExternalSysController'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.tagmanager", {
            url: '/tagmanager?selectTab',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/tagManager/tagManager_tpl.html',
                    controller: 'productManageMentAppTagManagerController'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.distributeconfig", {
            url: '/distributeconfig?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/distributeConfig/distributeConfig_tpl.html',
                    controller: 'productManageMentAppDistributeConfigCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.watermarkmgr", {
            url: '/watermarkmgr?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/watermarkMgr/watermarkMgr_tpl.html',
                    controller: 'productManageMentAppsitewatermarkMgrCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.app.thirdparty",{
            url: '/thirdparty?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/thirdPartyConfig/thirdPartyConfig_tpl.html',
                    controller: 'appThirdPartyConfigCtrl'
                },
                'header@manageconfig.productmanage.app': {
                    templateUrl: './manageConfig/productManageMent/app/headerRouter_tpl.html',
                    controller: 'proMgrAppHeaderRouterCtrl',
                }
            }
        });
}]);
